import * as React from 'react';
import { msdyn365Commerce } from '@msdyn365-commerce/core';
import { IGhSiteGateViewProps } from './gh-site-gate';

const HIDE_CSS = `body { visibility: hidden !important; } .gh-site-gate { visibility: visible !important; }`;

const GhSiteGateView: React.FC<IGhSiteGateViewProps> = props => {
    const { isUnlocked, heading, buttonText, errorMessage, siteGatePassword, cookieName } = props;

    const [error, setError] = React.useState(false);
    const [unlocked, setUnlocked] = React.useState(isUnlocked);
    const inputRef = React.useRef<HTMLInputElement>(null);

    // Client-side hydration check — if cookie is already set, unlock immediately
    React.useEffect(() => {
        if (!unlocked) {
            const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${cookieName}=([^;]*)`));
            if (match && match[1] === '1') {
                setUnlocked(true);
            }
        }
    }, []);

    if (unlocked) {
        return null;
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const value = inputRef.current?.value?.trim();
        if (value === siteGatePassword) {
            if (msdyn365Commerce.isBrowser) {
                const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
                document.cookie = `${cookieName}=1; path=/; expires=${expires}; SameSite=Lax`;
            }
            setUnlocked(true);
        } else {
            setError(true);
        }
    };

    // Inline script runs synchronously before paint — if the cookie exists,
    // override the HIDE_CSS so the page is visible while React hydrates.
    const unlockScript = `(function(){
        if (document.cookie.indexOf('${cookieName}=1') !== -1) {
            var s = document.createElement('style');
            s.textContent = 'body{visibility:visible!important}.gh-site-gate{display:none!important}';
            document.head.appendChild(s);
        }
    })();`;

    return (
        <div className='gh-site-gate'>
            <script dangerouslySetInnerHTML={{ __html: unlockScript }} />
            {/* SSR style tag: hides all page content except this module */}
            <style dangerouslySetInnerHTML={{ __html: HIDE_CSS }} />

            <div className='gh-site-gate__overlay'>
                <div className='gh-site-gate__dialog'>
                    <h2 className='gh-site-gate__heading'>{heading}</h2>
                    <form className='gh-site-gate__form' onSubmit={handleSubmit}>
                        <input
                            ref={inputRef}
                            className='gh-site-gate__input'
                            type='password'
                            autoFocus
                            autoComplete='off'
                            aria-label='Access code'
                        />
                        <button className='gh-site-gate__button' type='submit'>
                            {buttonText}
                        </button>
                    </form>
                    {error && <p className='gh-site-gate__error'>{errorMessage}</p>}
                </div>
            </div>
        </div>
    );
};

export default GhSiteGateView;
